import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ActionLink extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        children: PropTypes.node.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {href, onClick, children, ...props} = this.props;
        return (
            <a href="#" onClick={event => {
                if (onClick) onClick();
                event.preventDefault();
            }} {...props}>{children}</a>
        );
    }
}

export default ActionLink;


// WEBPACK FOOTER //
// ./src/controls/ActionLink.js